export enum UserErrorMessage {
  NotFoundUser = '내 정보를 찾을 수 없습니다.',
}
